// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__cFnJY","input":"nav_input__fY2yR","btn":"nav_btn__HETQp"};